<ng-template #credentialModal>
    <div class="modal-header">
        <h5 class="modal-title">
            {{ isPasswordCreateMode ? 'Create Login Credential' : 'Update Login Credential' }}
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.close()"></button>
    </div>

    <form [formGroup]="userLoginForm" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="modal-body">

            <div class="mb-3">
                <label>User Name</label>
                <input class="form-control" formControlName="userName" autocomplete="new-username">
                <div *ngIf="userLoginForm.controls.userName.touched &&
            userLoginForm.controls.userName.hasError('required')" class="text-danger">
                    Username is required.
                </div>

                <!-- Min Length -->
                <div *ngIf="userLoginForm.controls.userName.touched &&
            userLoginForm.controls.userName.hasError('minlength')" class="text-danger">
                    Username must be at least 4 characters.
                </div>

                <!-- Pattern -->
                <div *ngIf="userLoginForm.controls.userName.touched &&
            userLoginForm.controls.userName.hasError('pattern')" class="text-danger">
                    Only letters, numbers, dot, underscore & hyphen are allowed.
                </div>

                <!-- async error - Username taken -->
                <div *ngIf="userNameError" class="text-danger">
                    {{ userNameError }}
                </div>

                <!-- Valid message -->
                <div *ngIf="userNameValid" class="text-success">
                    Username available ✔
                </div>

                <!-- Show checking -->
                <div *ngIf="isCheckingUserName" class="text-info">
                    Checking availability…
                </div>


            </div>

            <div class="mb-3">
                <label>Password</label>
                <input type="password" class="form-control" formControlName="userPassword" autocomplete="new-password">
                <div *ngIf="userLoginForm.controls.userPassword.touched &&
            userLoginForm.controls.userPassword.hasError('required')" class="text-danger">
                    Password is required.
                </div>
            </div>

        </div>

        <div class="modal-footer">
            <button class="universal-submit-btn" type="submit">
                {{ isPasswordCreateMode ? 'Create' : 'Update' }}
            </button>
        </div>
    </form>
</ng-template>